let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3DOz6")).then(() => parcelRequire('2d2t8'));